import classnames from 'classnames'
import { MdKeyboardArrowUp } from 'react-icons/md'

import type { ReactElement } from 'react'

import { USER_OS, useOperatingSystem } from '~/utils/os'

export type DIGIT = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9'

import './styles.scss'

export interface KeyboardBindingProps {
  digit?: DIGIT
  size: SIZES
  type: 'ctrl' | 'digit'
}

const KeyboardButton = ({ digit = '1', size = 'medium', type = 'ctrl' }: KeyboardBindingProps): ReactElement => {
  const userOs = useOperatingSystem()

  const digitMapping =
    userOs === USER_OS.MAC
      ? { 0: 'à', 1: '&', 2: 'é', 3: `"`, 4: `'`, 5: '(', 6: '§', 7: 'è', 8: '!', 9: 'ç' }
      : { 0: 'à', 1: '&', 2: 'é', 3: `"`, 4: `'`, 5: '(', 6: '§', 7: 'è', 8: '!', 9: 'ç' }

  const containerClasses = classnames('control-button__container', size, { digit: type === 'digit' })

  return (
    <div className={containerClasses} role="button">
      {type === 'ctrl' ? (
        <>
          <div className="control-button__container__first-line">
            <MdKeyboardArrowUp color="#E5E1E1" size={size === 'medium' ? 18 : 12} />
          </div>
          <div className="control-button__container__second-line">control</div>
        </>
      ) : digit ? (
        <>
          <div className="control-button__container__first-line">{digit}</div>
          <div className="control-button__container__second-line">{digitMapping[digit]}</div>
        </>
      ) : null}
    </div>
  )
}

export default KeyboardButton
